import { placementForFlower, FLOWER_IMAGES } from "../lib/garden";

export function BloomGarden({
  flowerCount,
  dimmed = false,
}: {
  flowerCount: number;
  dimmed?: boolean;
}) {
  if (flowerCount <= 0) return null;

  return (
    <div
      className={dimmed ? "bloom-garden bloom-garden--dimmed" : "bloom-garden"}
      aria-hidden="true"
    >
      {Array.from({ length: flowerCount }, (_, index) => {
        const placement = placementForFlower(index);
        const flowerTransform = [
          placement.mirror ? "scaleX(-1)" : "",
          `rotate(${placement.rotateDeg}deg)`,
          `scale(${placement.scale})`,
        ]
          .filter(Boolean)
          .join(" ");

        return (
          <div
            key={index}
            className="bloom-garden__flower-wrap"
            style={{
              left: `${placement.leftPercent}%`,
              zIndex: placement.zIndex,
            }}
          >
            <img
              className="bloom-garden__flower"
              src={FLOWER_IMAGES[placement.imageIndex]}
              alt=""
              style={{ transform: flowerTransform }}
            />
          </div>
        );
      })}
    </div>
  );
}
